import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/types'
import { Roles } from '../types'
import { useMfeRoute } from '../../mfe'

const useRouteAuthorization = (): boolean => {
  const { isCurrentRouteFromMfe, route } = useMfeRoute()

  const userInfo = useSelector((state: RootState) => state.auth.user.info)

  return useMemo((): boolean => {
    if (!isCurrentRouteFromMfe) return true

    const currentMfeRouteRequiresRoles = route.acceptedRoles.length > 0

    if (!currentMfeRouteRequiresRoles) return true

    const currentRoles: Roles[] = (userInfo?.roles as Roles[] | undefined) ?? []

    return route.acceptedRoles.some((role) => currentRoles.includes(role))
  }, [isCurrentRouteFromMfe, route?.acceptedRoles, userInfo?.roles])
}

export default useRouteAuthorization
